// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageWrapper_wrapper_7FGrJ","transparent":"PageWrapper_transparent_bkdYj"};